(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda appointment status
    module.directive('agendaAppointmentVideoconsultStatus', [
        '$rootScope',
        '$window',
        '$translate',
        '$timeout',
        'Alert',
        'AppointmentService', 
        'AgendaBroadcast', 
        'WebsocketService',
        'WebsocketRegisterType',        
        function (
            $rootScope,
            $window,
            $translate,
            $timeout,
            Alert,
            AppointmentService, 
            AgendaBroadcast,
            WebsocketService,
            WebsocketRegisterType) {

        var directive = {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-appointment-videoconsult-status.template.html',
            scope: {
                id: '=',
                bigIcon: '=',
                patientEnteredMeetingRoom: '=',
                endDateAppointment: '=',
                isPaid: '=',
            },
            link: link
        };
        return directive;

        function link(scope, element) {

            scope.blink = false;

            activate();

            function listen() {
                // status changed
                let wsAppointmentVideoConsultUpdated = WebsocketService.register(WebsocketRegisterType.VideoConsultStarted, function (obj) {

                    if (obj.data.appointmentId === scope.id) {
                        
                        let newState = obj.data.patientEnteredMeetingRoom;

                        if (scope.patientEnteredMeetingRoom &&
                            scope.patientEnteredMeetingRoom === newState) { 
                                return; 
                        }
                                                
                        $timeout(function() {
                            scope.patientEnteredMeetingRoom = newState;
                            setVideoConsultActive(newState, scope.endDateAppointment);
                            scope.blink = true;
                        });
                        let appointmentDate = moment(obj.data.date);
                        let message = $translate.instant('patient_arrived', {datetime: appointmentDate.format('dddd DD MMMM YYYY H:mm')});
                        Alert.success(message);
                    }
                });


                // on destroy
                scope.$on("$destroy", function () {
                    if (wsAppointmentVideoConsultUpdated) {
                        WebsocketService.unregister(wsAppointmentVideoConsultUpdated.id);
                    }
                });

            }
            
            // send confirmation messges
            scope.sendMeetingRoomReminders = function () {
                AppointmentService.sendReminderMessage(scope.id).then(function (result) {
                    Alert.success($translate.instant('messages_scheduled'));
                });
            };

            scope.openMeetingRoom = function () {
                AppointmentService.getAppointmentMeetingRoomUrl(scope.id, false).then(function (result) {
                    $window.open(result, "_blank");
                });
            };

            scope.copyMeetingUrl = function (patientUrl) {
                AppointmentService.getAppointmentMeetingRoomUrl(scope.id, patientUrl).then(function (result) {
                    navigator.clipboard.writeText(result)
                        .then(r => Alert.translateSuccess('copied'))
                        .catch(r => Alert.error('failed_copy'));
                });
            };

            // activation work
            function activate() {
                setVideoConsultActive(scope.patientEnteredMeetingRoom, scope.endDateAppointment)         
                listen();               
            }
            
            function setVideoConsultActive(patientEnteredMeetingRoom, endDateAppointment){
                let endDateExtraHours = moment(endDateAppointment).add({ hours: 1 });
                scope.blink = patientEnteredMeetingRoom && endDateExtraHours >= moment(new Date());
            }
        }
}]);
})();